/* import __COLOCATED_TEMPLATE__ from './event-part-assignment-rules-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();